export default __webpack_public_path__ + "static/media/step2.013de3b8.webp";